// extracted by mini-css-extract-plugin
module.exports = {"root":"_d5dcaa","icon":"_b70804","title":"_9bbe45","tagline":"_827e7d"};